import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import authService from "../../../services/AuthService";
import VNavMenuItem from "./VerticalNavMenuItem.vue";
export default {
  name: "v-nav-menu-group",
  props: {
    openHover: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object
    },
    groupIndex: {
      type: Number
    }
  },
  components: {
    VNavMenuItem: VNavMenuItem
  },
  data: function data() {
    return {
      maxHeight: "0px",
      openItems: false,
      searchedValue: "",
      isPrivileged: authService.privileged
    };
  },
  computed: {
    searchedSubMenuGroup: function searchedSubMenuGroup() {
      var _this = this;

      if (this.searchedValue.length === 0) {
        return this.group.submenu;
      }

      return this.group.submenu.filter(function (item) {
        var _item$name;

        return (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(_this.searchedValue.toLowerCase());
      });
    },
    verticalNavMenuItemsMin: function verticalNavMenuItemsMin() {
      return this.$store.state.verticalNavMenuItemsMin;
    },
    styleItems: function styleItems() {
      return {
        maxHeight: this.maxHeight
      };
    },
    itemIcon: function itemIcon() {
      return function (index) {
        if (!((index.match(/\./g) || []).length > 1)) return "CircleIcon";
      };
    },
    isGroupActive: function isGroupActive() {
      var _this2 = this;

      return function (item) {
        var path = _this2.$route.fullPath;
        var open = false;
        var routeParent = _this2.$route.meta ? _this2.$route.meta.parent : undefined;

        var func = function func(item) {
          if (item.submenu) {
            item.submenu.forEach(function (item) {
              if ((path == item.url || routeParent == item.slug) && item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };

        func(item);
        return open;
      };
    }
  },
  watch: {
    // OPEN & CLOSES DROPDOWN ON ROUTE CHANGE
    $route: function $route() {
      var _this3 = this;

      if (this.verticalNavMenuItemsMin) return;
      var scrollHeight = this.scrollHeight; // Collapse Group

      if (this.openItems && !this.open) {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this3.maxHeight = "".concat(0, "px");
        }, 50); // Expand Group
      } else if (this.open) {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this3.maxHeight = "none";
        }, 300);
      }
    },
    maxHeight: function maxHeight() {
      this.openItems = this.maxHeight != "0px";
    },
    // OPEN AND CLOSES DROPDOWN MENU ON NavMenu COLLAPSE AND DEFAULT VIEW
    "$store.state.verticalNavMenuItemsMin": function $storeStateVerticalNavMenuItemsMin(val) {
      var _this4 = this;

      var scrollHeight = this.$refs.items.scrollHeight;

      if (!val && this.open) {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this4.maxHeight = "none";
        }, 300);
      } else {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this4.maxHeight = "0px";
        }, 50);
      }

      if (val && this.open) {
        this.maxHeight = "".concat(scrollHeight, "px");
        setTimeout(function () {
          _this4.maxHeight = "0px";
        }, 250);
      }
    }
  },
  methods: {
    clickNavItem: function clickNavItem() {
      this.searchedValue = "";
    },
    clickGroup: function clickGroup() {
      var _this5 = this;

      if (!this.openHover) {
        var thisScrollHeight = this.$refs.items.scrollHeight;

        if (this.maxHeight == "0px") {
          this.maxHeight = "".concat(thisScrollHeight, "px");
          setTimeout(function () {
            _this5.maxHeight = "none";
          }, 300);
        } else {
          this.maxHeight = "".concat(thisScrollHeight, "px");
          setTimeout(function () {
            _this5.maxHeight = "".concat(0, "px");
          }, 50);
        }

        this.$parent.$children.map(function (child) {
          if (child.isGroupActive) {
            if (child !== _this5 && !child.open && child.maxHeight != "0px") {
              setTimeout(function () {
                child.maxHeight = "".concat(0, "px");
              }, 50);
            }
          }
        });
      }
    },
    mouseover: function mouseover() {
      if (this.openHover) {
        var scrollHeight = this.$refs.items.scrollHeight;
        this.maxHeight = "".concat(scrollHeight, "px");
      }
    },
    mouseout: function mouseout() {
      if (this.openHover) {
        var scrollHeight = 0;
        this.maxHeight = "".concat(scrollHeight, "px");
      }
    }
  },
  mounted: function mounted() {
    this.openItems = this.open;

    if (this.open) {
      this.maxHeight = "none";
    }
  }
};